var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('z-stance',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStance),expression:"showStance"}],attrs:{"btn-text":_vm.btnText,"show-info":false,"descText":_vm.stanceInfo},on:{"click":_vm.checkStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }